module.exports = __webpack_public_path__ + "static/media/VID_20170905_191735.cfabe31f.mp4";